// AUTO-GENERATED SQL Builder (V40 Final) for WhatsAppSendLog
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class WhatsAppSendLogSql {
  private ast = new SqlAst('WhatsAppSendLog', 'whatsAppSendLog');
  public readonly main: any = {};

  public guid: SqlField;
  public templateCode: SqlField;
  public templateLabel: SqlField;
  public audience: SqlField;
  public body: SqlField;
  public recipientsJson: SqlField;
  public recipientCount: SqlField;
  public sentCount: SqlField;
  public status: SqlField;
  public instanceId: SqlField;
  public sentDate: SqlField;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('whatsAppSendLog', 'guid', '', 'id', 'whatsAppSendLog_guid');
    this.templateCode = new SqlField('whatsAppSendLog', 'templateCode', '', 'id', 'whatsAppSendLog_templateCode');
    this.templateLabel = new SqlField('whatsAppSendLog', 'templateLabel', '', 'id', 'whatsAppSendLog_templateLabel');
    this.audience = new SqlField('whatsAppSendLog', 'audience', '', 'id', 'whatsAppSendLog_audience');
    this.body = new SqlField('whatsAppSendLog', 'body', '', 'id', 'whatsAppSendLog_body');
    this.recipientsJson = new SqlField('whatsAppSendLog', 'recipientsJson', '', 'id', 'whatsAppSendLog_recipientsJson');
    this.recipientCount = new SqlField('whatsAppSendLog', 'recipientCount', '', 'id', 'whatsAppSendLog_recipientCount');
    this.sentCount = new SqlField('whatsAppSendLog', 'sentCount', '', 'id', 'whatsAppSendLog_sentCount');
    this.status = new SqlField('whatsAppSendLog', 'status', '', 'id', 'whatsAppSendLog_status');
    this.instanceId = new SqlField('whatsAppSendLog', 'instanceId', '', 'id', 'whatsAppSendLog_instance');
    this.sentDate = new SqlField('whatsAppSendLog', 'sentDate', '', 'id', 'whatsAppSendLog_sentDate');
    this.id = new SqlField('whatsAppSendLog', 'id', '', 'id', 'whatsAppSendLog_id');
    this.isDeleted = new SqlField('whatsAppSendLog', 'isDeleted', '', 'id', 'whatsAppSendLog_isDeleted');
    this.createdBy = new SqlField('whatsAppSendLog', 'createdBy', '', 'id', 'whatsAppSendLog_createdBy');
    this.createdDate = new SqlField('whatsAppSendLog', 'createdDate', '', 'id', 'whatsAppSendLog_createdDate');
    this.updatedBy = new SqlField('whatsAppSendLog', 'updatedBy', '', 'id', 'whatsAppSendLog_updatedBy');
    this.updatedDate = new SqlField('whatsAppSendLog', 'updatedDate', '', 'id', 'whatsAppSendLog_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:WhatsAppSendLogSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:WhatsAppSendLogSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:WhatsAppSendLogSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:WhatsAppSendLogSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:WhatsAppSendLogSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:WhatsAppSendLogSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:WhatsAppSendLogSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:WhatsAppSendLogSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:WhatsAppSendLogSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:WhatsAppSendLogSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
